/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const useCredential = () => {
  const urlParams = new URLSearchParams(window.location.search);
  let userId = urlParams.get("userId");
  let id = urlParams.get("id");
  if (userId) {
    userId = String(userId).trim();
  }
  if (id) {
    id = String(id).trim();
  }
  return {
    userId,
    id
  };
};
